// src/gestion-logistics/components/TransportModeIcon.tsx
import React from "react";
import { Plane } from "lucide-react";
import { Tag, Tooltip } from "antd";
import {
  RocketOutlined,
  CarOutlined,
  DeploymentUnitOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { TransportMode } from "../types/shipment.types";

interface TransportModeIconProps {
  mode: TransportMode;
  showLabel?: boolean;
  size?: "small" | "default";
}

/**
 * Composant pour afficher l'icône et le libellé du mode de transport
 */
const TransportModeIcon: React.FC<TransportModeIconProps> = ({
  mode,
  showLabel = true,
  size = "default",
}) => {
  const getModeConfig = () => {
    switch (mode) {
      case TransportMode.SEA:
        return {
          icon: <RocketOutlined />,
          text: "Maritime",
          color: "blue",
          tooltip: "Transport Maritime",
        };
      case TransportMode.AIR:
        return {
          icon: <Plane size={16} strokeWidth={1.8} aria-hidden="true" style={{ verticalAlign: "middle" }} />,
          text: "Aérien",
          color: "cyan",
          tooltip: "Transport Aérien",
        };
      case TransportMode.ROAD:
        return {
          icon: <CarOutlined />,
          text: "Routier",
          color: "orange",
          tooltip: "Transport Routier",
        };
      case TransportMode.RAIL:
        return {
          icon: <DeploymentUnitOutlined />,
          text: "Ferroviaire",
          color: "purple",
          tooltip: "Transport Ferroviaire",
        };
      case TransportMode.MULTIMODAL:
        return {
          icon: <GlobalOutlined />,
          text: "Multimodal",
          color: "green",
          tooltip: "Transport Multimodal",
        };
      default:
        return {
          icon: <GlobalOutlined />,
          text: mode,
          color: "default",
          tooltip: mode,
        };
    }
  };

  const config = getModeConfig();

  if (!showLabel) {
    return (
      <Tooltip title={config.tooltip}>
        <span
          style={{
            fontSize: size === "small" ? "14px" : "16px",
            color: `var(--ant-${config.color}-6)`,
          }}
        >
          {config.icon}
        </span>
      </Tooltip>
    );
  }

  return (
    <Tag
      icon={config.icon}
      color={config.color}
      style={{
        fontSize: size === "small" ? "12px" : "14px",
        padding: size === "small" ? "2px 8px" : "4px 12px",
      }}
    >
      {config.text}
    </Tag>
  );
};

export default TransportModeIcon;
